<template>
    <div id="workstation-form-page">
        <workstation-form :form-type="'add'"></workstation-form>
    </div>
</template>
<script>
import WorkstationForm from '../components/workstations/WorkstationForm';
export default {
    components: {
        'workstation-form': WorkstationForm,
    },
};
</script>
